import { render, staticRenderFns } from "./CategorySupplyDemandFilters.vue?vue&type=template&id=7a8c23a0&scoped=true"
import script from "./CategorySupplyDemandFilters.vue?vue&type=script&lang=js"
export * from "./CategorySupplyDemandFilters.vue?vue&type=script&lang=js"
import style0 from "./CategorySupplyDemandFilters.vue?vue&type=style&index=0&id=7a8c23a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8c23a0",
  null
  
)

export default component.exports